import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import BookExtracts from './components/BookExtracts/BookExtracts';
import './App.scss';

function App() {
  return (
    <div className="app">
      <Header/>
      <BookExtracts/>
      <Footer/>
    </div>
  );
}

export default App;
